import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AuthIntent {
  intent: string | null;
  source: string | null;
  returnTo: string | null;
}

interface AuthIntentContextType {
  authIntent: AuthIntent;
  setAuthIntent: (intent: AuthIntent) => void;
}

const AuthIntentContext = createContext<AuthIntentContextType | undefined>(undefined);

export const useAuthIntent = () => {
  const context = useContext(AuthIntentContext);
  if (!context) {
    throw new Error('useAuthIntent must be used within AuthIntentProvider');
  }
  return context;
};

interface AuthIntentProviderProps {
  children: ReactNode;
}

export const AuthIntentProvider: React.FC<AuthIntentProviderProps> = ({ children }) => {
  const [authIntent, setAuthIntent] = useState<AuthIntent>({ 
    intent: null, 
    source: null,
    returnTo: null 
  });

  return (
    <AuthIntentContext.Provider value={{ authIntent, setAuthIntent }}>
      {children}
    </AuthIntentContext.Provider>
  );
};
